import { baseGatewayApiV1 } from '@verantos-dev/app-state-base';
import { COHORTS_PATH } from '@verantos-dev/core-constants';
import {
  type CohortSummaryDetails,
  type CohortSummaryAttributeResult,
} from '@verantos-dev/types-cohorts';
import { type ObjectResponse } from '@verantos-dev/types-common';

// Types for custom clinical characteristics
export interface CustomClinicalCharacteristicsRequest {
  conceptGroups: string[];
  domain: string;
}

export interface CustomClinicalCharacteristicsResponse {
  cohortResultId: string;
  requestedConceptGroups: string[];
  requestedDomain: string;
  characteristics: CohortSummaryAttributeResult[];
}

export const datasetApiSlice = baseGatewayApiV1
  .enhanceEndpoints({
    addTagTypes: ['cohortSummary'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCohortSummaryByCohortProfileId: builder.query<
        ObjectResponse<CohortSummaryDetails>,
        { projectId: string; cohortProfileId: string }
      >({
        query: ({ projectId, cohortProfileId }) =>
          `/${COHORTS_PATH}/${projectId}/cohort-profile/${cohortProfileId}/summary`,
        providesTags: (result, error, { cohortProfileId }) => [
          { type: 'cohortSummary', id: cohortProfileId },
        ],
      }),
      getCustomClinicalCharacteristics: builder.mutation<
        ObjectResponse<CustomClinicalCharacteristicsResponse>,
        {
          projectId: string;
          cohortProfileId: string;
          request: CustomClinicalCharacteristicsRequest;
        }
      >({
        query: ({ projectId, cohortProfileId, request }) => ({
          url: `/${COHORTS_PATH}/${projectId}/cohort-profile/${cohortProfileId}/clinical-characteristics`,
          method: 'POST',
          body: request,
        }),
        invalidatesTags: (result, error, { cohortProfileId }) => [
          { type: 'cohortSummary', id: cohortProfileId },
        ],
      }),
    }),
  });

export const {
  useGetCohortSummaryByCohortProfileIdQuery,
  useLazyGetCohortSummaryByCohortProfileIdQuery,
  useGetCustomClinicalCharacteristicsMutation,
} = datasetApiSlice;
